import { render } from "./PageComponent.vue?vue&type=template&id=11b90580"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__